import React from 'react'

import { ReactTypeformEmbed } from 'react-typeform-embed'
import InstagramEmbed from 'react-instagram-embed'

import Link from '../components/Link'

import footprints from '../images/Footprints.png'
import studentConnect from '../images/student_connect.jpg'

import studentFlyer from '../images/students_flyers.jpg'

const StudentsPage = () => (
  <div>
    <section className="grey">
      <div className="container small-padding">
        <div className="row">
          <h2 style={{ fontSize: '2em' }}>FRESHERS 2019</h2>
          <h3 style={{ marginTop: 0 }}>Coming to Portsmouth this Autumn?</h3>
          <p className="lead">
            BBQs, student meals, bible studies, food, more food. <br /> We're
            looking forward to welcoming you to Portsmouth, let us know you're
            coming below 👍
          </p>

          <div
            style={{ display: 'block', position: 'relative', height: '500px' }}
          >
            <ReactTypeformEmbed
              popup={false}
              url="https://nathan341.typeform.com/to/usLqEm"
            />
          </div>
        </div>
      </div>
    </section>
    <section className="instagram blue">
      <div className="container small-padding">
        <div className="row">
          <h2>Follow us on Instagram</h2>
          <p>
            <a href="http://instagram.com/cornerstonechurchportsmouth">
              @cornerstonechurchportsmouth
            </a>
          </p>
          {/* <script src="//lightwidget.com/widgets/lightwidget.js" /> */}
          {/* <iframe src="//lightwidget.com/widgets/0f3a2a79c75c5f3c95ae11b862b53d6c.html" scrolling="no" allowTransparency={true} className="lightwidget-widget"
                        style={{ width: "100%", border: "0", overflow: "hidden" }}></iframe>
                    <br />
                    <br /> */}
          <p>
            and Facebook
            <a href="https://www.facebook.com/cornerstonechurchportsmouth/">
              @cornerstonechurchportsmouth
            </a>
          </p>
        </div>
      </div>
    </section>
    <section id="students" className="students">
      <div className="container">
        <div className="row">
          <div className="col-md-6">
            <img src={studentFlyer} style={{ width: '100%' }} />
          </div>
          <div className="col-md-6">
            <h1>Students at Cornerstone</h1>
            <p className="lead">
              Your University years are a fantastic opportunity to come to know
              Jesus more and we at Cornerstone Church Portsmouth are serious
              about helping you to do just that.
            </p>
            <p className="lead">
              By the time you graduate, we want you to leave with your faith
              deepened, your mind stretched and to be trained and equipped for a
              lifetime of serving Jesus.{' '}
            </p>

            <p className="lead">
              We think the following will help reach that goal…
            </p>

            <div className="student-links">
              <p>
                <Link href="#student-connect">Student midweek connect</Link>
              </p>
              <p>
                <Link href="#real">Real homes &amp; real food</Link>
              </p>
              <p>
                <Link href="#one-to-ones">One-to-ones</Link>
              </p>
              <p>
                <Link href="#sunday-gathering">Sunday gathering</Link>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section id="student-connect" className="grey">
      <div className="container">
        <div className="row">
          <div className="col-md-6 grey">
            <h2>Student midweek connect</h2>
            <h4>Wednesday, 7.30pm</h4>
            <p>
              Each week during term time the students meet for a bible study at
              a local cafe.
            </p>
            <p>
              Email Rob to find out more:{' '}
              <a href="mailto:rob@cornerstonechurchportsmouth.org">
                rob@cornerstonechurchportsmouth.org
              </a>
            </p>
          </div>
          <div className="col-md-6 image">
            <InstagramEmbed
              url="https://www.instagram.com/p/Bpj43Nll07j/"
              hideCaption={true}
            />
          </div>
        </div>
      </div>
    </section>

    <section id="real" className="real blue">
      <div className="container">
        <div className="row">
          <div className="col-md-6 text">
            <h2>Real homes & real food</h2>
            <p>
              On a regular basis students will be invited to break out of the
              student-bubble and have, along with others, Sunday lunch or dinner
              in the home of someone in the church.
            </p>
            <p>
              Whatever year you are in, whatever your nationality, whatever your
              knowledge of Jesus – we would love to welcome at Cornerstone. We
              want to support you and help you make the most of your time as a
              student.
            </p>
          </div>
          <div className="col-md-6">
            <InstagramEmbed
              url="https://www.instagram.com/p/BrUlKtBl_3Z"
              hideCaption={true}
            />{' '}
          </div>
        </div>
      </div>
    </section>

    <section id="one-to-ones" className="one-to-ones">
      <div className="container">
        <div className="row">
          <div className="col-md-6 hidden-xs">
            <InstagramEmbed
              url="https://www.instagram.com/p/BimdndphdO5/"
              hideCaption={true}
            />
          </div>
          <div className="col-md-6">
            <h2>One to ones</h2>
            <p>
              We aim to give every student the opportunity to meet up with an
              older Christian (usually at one of the many local coffee shops!)
              for bible study, prayer and encouragement.{' '}
            </p>
            <p>
              If that is something you would appreciate then we’ll do our best
              to partner you with someone we think you'll click with and who's a
              bit further down the track in the Christian life.
            </p>
            <p>
              When you meet there will be opportunity to ask questions, explore
              issues and seek advice and direction.
            </p>
          </div>
        </div>
      </div>
    </section>

    <section id="sunday-gathering" className="sundays grey">
      <div className="container">
        <div className="row">
          <div className="col-md-6 mobile-box grey">
            <h2>Our Sunday gathering</h2>
            <p>
              Each Sunday, when Cornerstone meets together, students have the
              opportunity to be part of a loving, mixed and supportive church
              family.
            </p>
            <p>
              Friendship House, in Elm Grove, is the venue for our Sunday
              gathering and is just a short walk from the University buildings
              and halls.
            </p>
            <p>
              When we meet together there will be contemporary music, heartfelt
              prayer and a Bible talk. We believe that as the Bible is taught
              faithfully and clearly – people have the opportunity to come to
              know Jesus more.
            </p>
          </div>
          <div className="col-md-6">
            <div className="google-maps">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d20177.92653500724!2d-1.093095060649006!3d50.78964548183031!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48745d980b7d1579%3A0x4b354ae148906e2c!2sCornerstone+Church+Portsmouth!5e0!3m2!1sen!2suk!4v1557065373255!5m2!1sen!2suk"
                width="470"
                height="400"
                frameBorder="0"
                style={{ border: '0' }}
                allowFullScreen
              />
            </div>
          </div>
        </div>
      </div>
    </section>

    <section className="footer">
      <div className="container">
        <div className="row">
          <h2>Any questions?</h2>
          <p>
            Please feel free to get in contact via:
            <a href="mailto:info@cornerstonechurchportsmouth.org">
              info@cornerstonechurchportsmouth.org
            </a>
          </p>
        </div>
      </div>
    </section>
    <script async src="//www.instagram.com/embed.js" />
  </div>
)

export default StudentsPage



// WEBPACK FOOTER //
// ./src/pages/students.js